import React from 'react';
import NumberFormat from 'react-number-format';

function NumberFormatField(props) {
    const { inputRef, onChange, decimalScale = 18, ...other } = props;

    return (
        <NumberFormat
            {...other}
            allowLeadingZeros={false}
            allowNegative={false}
            decimalScale={decimalScale}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                        float: values.floatValue,
                        formattedValue: values.formattedValue,
                    },
                });
            }}
            thousandSeparator
        />
    );
}

export default NumberFormatField;
